import React, { useEffect, useRef } from "react";
import styles from "./Features.module.css";
import { Clock, Users, Palette, Home } from "lucide-react";

const Features = () => {
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible);
          }
        });
      },
      { threshold: 0.2 } // Triggers when 20% of the card is visible
    );

    cardRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);
  const data = [
    {
      title: "Affordable fees and flexible scheduling",
      text: "Affordable fees compared to other similar institutions in the area. Classes are available during weekdays, weekends, and evenings. Online, offline and 1 on one classes are available.",
      icon: <Clock />,
      color: "#ff8c00", // Orange
    },
    {
      title: "Expert Guidance",
      text: "Our instructors are trained, talented and experienced. They are dedicated to helping you find your inner artist. We always offer proper guidance and feedback in a fun way.",
      icon: <Users />,
      color: "#2ecc71", // Green
    },
    {
      title: "Emphasis on variety",
      text: "We offer a variety of classes starting from crayon color to advanced courses with different medium and technic of art like oil pastel, water color, acrylic, and more.",
      icon: <Palette />,
      color: "#ff8c00",
    },
    {
      title: "Inspiring Atmosphere",
      text: "Our home based studio is a vibrant, welcoming space filled with tools and resources. It is the most private and intimate place an artist can have.",
      icon: <Home />,
      color: "#2ecc71",
    },
  ];

  return (
    <section className={styles.wrapper}>
      <h2 className={styles.heading}>Why <span>Nupur Creations?</span></h2>
      <div className={styles.grid}>
        {data.map((item, index) => (
          <div 
            key={index} 
            ref={(el) => { cardRefs.current[index] = el; }}
            className={styles.card} 
            style={{ 
              borderColor: item.color,
              // Staggered delay: each card appears 150ms after the previous one
              transitionDelay: `${index * 150}ms` 
            }}
          >
            <div className={styles.iconBox} style={{ color: item.color }}>
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
